/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IIamCheckOtpParams, IIamCheckPasswordPolicyParams, IIamIdentifyUserParams, IIamResetPasswordParams } from '../../api/domain';
import type { IamPasswordValidationError } from '../../enum';

enum IamApiActions {
    IDENTIFY_USER = 'iam.password-reset.identify-user',
    IDENTIFY_USER_SUCCESS = 'iam.password-reset.identify-user.SUCCESS',
    IDENTIFY_USER_FAILURE = 'iam.password-reset.identify-user.FAILURE',

    CHECK_OTP = 'iam.password-reset.check-otp',
    CHECK_OTP_SUCCESS = 'iam.password-reset.check-otp.SUCCESS',
    CHECK_OTP_FAILURE = 'iam.password-reset.check-otp.FAILURE',

    CHECK_PASSWORD_POLICY = 'iam.password-reset.check-password-policy',
    CHECK_PASSWORD_POLICY_SUCCESS = 'iam.password-reset.check-password-policy.SUCCESS',
    CHECK_PASSWORD_POLICY_FAILURE = 'iam.password-reset.check-password-policy.FAILURE',

    RESET_PASSWORD = 'iam.password-reset.reset-password',
    RESET_PASSWORD_SUCCESS = 'iam.password-reset.reset-password.SUCCESS',
    RESET_PASSWORD_FAILURE = 'iam.password-reset.reset-password.FAILURE',

    CANCEL_PASSWORD_RESET = 'iam.password-reset.cancel-password-reset',
    CANCEL_PASSWORD_RESET_SUCCESS = 'iam.password-reset.cancel-password-reset.SUCCESS',
    CANCEL_PASSWORD_RESET_FAILURE = 'iam.password-reset.cancel-password-reset.FAILURE',
}

export const identifyUser = createAction<IIamIdentifyUserParams>(IamApiActions.IDENTIFY_USER);
export const identifyUserSuccess = createAction(IamApiActions.IDENTIFY_USER_SUCCESS);
export const identifyUserFailure = createAction<unknown>(IamApiActions.IDENTIFY_USER_FAILURE);

export const checkOtp = createAction<IIamCheckOtpParams>(IamApiActions.CHECK_OTP);
export const checkOtpSuccess = createAction(IamApiActions.CHECK_OTP_SUCCESS);
export const checkOtpFailure = createAction<unknown>(IamApiActions.CHECK_OTP_FAILURE);

export const checkPasswordPolicy = createAction<IIamCheckPasswordPolicyParams>(IamApiActions.CHECK_PASSWORD_POLICY);
export const checkPasswordPolicySuccess = createAction(IamApiActions.CHECK_PASSWORD_POLICY_SUCCESS);
export const checkPasswordPolicyFailure = createAction<IamPasswordValidationError>(IamApiActions.CHECK_PASSWORD_POLICY_FAILURE);

export const resetPassword = createAction<IIamResetPasswordParams>(IamApiActions.RESET_PASSWORD);
export const resetPasswordSuccess = createAction(IamApiActions.RESET_PASSWORD_SUCCESS);
export const resetPasswordFailure = createAction<unknown>(IamApiActions.RESET_PASSWORD_FAILURE);

export const cancelPasswordReset = createAction(IamApiActions.CANCEL_PASSWORD_RESET);
export const cancelPasswordResetSuccess = createAction(IamApiActions.CANCEL_PASSWORD_RESET_SUCCESS);
export const cancelPasswordResetFailure = createAction<unknown>(IamApiActions.CANCEL_PASSWORD_RESET_FAILURE);
